import { render, staticRenderFns } from "./IconGrade.vue?vue&type=template&id=52aceca6"
import script from "./IconGrade.vue?vue&type=script&lang=ts"
export * from "./IconGrade.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports